import { useState } from "react";
import { useLang } from "../lib/useLang";
import { useCart } from "../state/CartContext";
import { formatKWD } from "../lib/format";

/** Promo-code entry + applied-state chip. Discounts subtotal only. */
export function PromoField() {
  const { t, lang, pick } = useLang();
  const { applyPromo, clearPromo, promoCode, promoInvalid, discount } = useCart();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  // A valid, applied code (present and actually discounting or at least matched).
  const applied = promoCode && !promoInvalid;

  function submit() {
    const res = applyPromo(code);
    if (res.ok) {
      setCode("");
      setError("");
    } else if (res.reason === "belowMin") {
      setError(t("promo.belowMin", { min: formatKWD(res.minSubtotal ?? 0, lang) }));
    } else if (res.reason === "expired") {
      setError(t("promo.expired"));
    } else {
      setError(t("promo.invalid"));
    }
  }

  if (applied) {
    return (
      <div className="flex items-center justify-between rounded-xl border border-brand/20 bg-brand/5 p-3">
        <span className="flex items-center gap-2 text-sm">
          <span>🎟️</span>
          <span className="font-semibold text-brand">{promoCode}</span>
          <span className="text-black/50">
            −{formatKWD(discount, lang)}
          </span>
        </span>
        <button
          onClick={() => {
            clearPromo();
            setError("");
          }}
          className="text-sm font-semibold text-black/45 hover:text-brand"
        >
          {t("promo.remove")}
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-1.5">
      <div className="flex gap-2">
        <input
          className="input flex-1"
          value={code}
          onChange={(e) => {
            setCode(e.target.value);
            setError("");
          }}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), submit())}
          placeholder={t("promo.placeholder")}
          dir={lang === "ar" ? "rtl" : "ltr"}
          aria-label={t("promo.title")}
        />
        <button
          className="btn-outline shrink-0"
          onClick={submit}
          disabled={!code.trim()}
        >
          {t("promo.apply")}
        </button>
      </div>
      {(error || promoInvalid) && (
        <p className="text-xs font-semibold text-brand">
          {error || t("promo.noLongerValid", { code: pick(promoCode ?? "", promoCode ?? "") })}
        </p>
      )}
    </div>
  );
}
